module.exports = __webpack_public_path__ + "static/img/cockpit.d41d8cd9.svg";